import React from "react";
import Classes from "./styles/style.module.css";
import UserAvatar from "../../components/UserAvatar";
import { useSelector } from "react-redux";

const NavUserSection = () => {
  const { currentUser } = useSelector(({ user }) => user);
  return (
    <div className={Classes.userSection}>
      <UserAvatar user={currentUser} />
    </div>
  );
};

export default NavUserSection;
